import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { serviceURLService } from '../service/serviceURL';
import { SharingDataService } from '../service/sharing-data.service';
import { environment } from './../../environments/environment';

import { Subject } from 'rxjs/internal/Subject';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';

@Component({
  selector: 'app-doctors-professional-indemnity',
  templateUrl: './doctors-professional-indemnity.component.html',
  styleUrls: ['./doctors-professional-indemnity.component.css']
})
export class DoctorsProfessionalIndemnityComponent implements OnInit {
  loading: boolean;
  specialization: string = "Eye Specialist";
  partnerId: any;
  prospectId: any;
  userDetails: any = {};
  subOptions: any = [];
  subOptionsvalue: any;
  private onDestroy$: Subject<void> = new Subject<void>();

  constructor(private _location: Location, private router: Router, private activatedRoute: ActivatedRoute, private serviceURLService: serviceURLService, public sharingDataService: SharingDataService) {
    this.userDetails.name = localStorage.getItem('name');
    this.userDetails.email = localStorage.getItem('email');
    this.userDetails.mobile = localStorage.getItem('mobileNumber');
    this.activatedRoute.queryParams.subscribe(params => {
      this.partnerId = params['partner'];
    });
  }

  ngOnInit() {
    if (!this.partnerId) {
      this.partnerId = environment.production ? '997' : '997';
    }
  
  }

  createProspect(clicked) {
    const data = {
      mobile: this.userDetails.mobile,
      prospectId: "",
      rmId: "",
      product: 83,
      email: this.userDetails.email,
      name: this.userDetails.name,
      company: "",
      location: "",
      designation: "",
      comment: "",
      partnerId: this.partnerId,
      channel: "Notify-App",
      leadSource: "Notify-App",
      googleClickID: "",
      couponCode: ""
    }
    this.prospectId = localStorage.getItem('prospectIdPI');
    // if (!this.prospectId) {
      this.serviceURLService.createProspect(data).pipe(takeUntil(this.onDestroy$)).subscribe((successData: any) => {
        this.prospectId = successData.data.prospectId;
        localStorage.setItem("prospectIdPI", this.prospectId);

        if(clicked){
          this.submitSpecialization()
        }
      }, errorData => {

      });
    // }
    
  }

  selectedSpecialization() {
    if(this.specialization=="Radiologist"){
    this.subOptions=["Consultant Radiologist", "Interventional Radiologist", "Neurologist Radiologist", "Nuclear Medicine Radiologist",
    "Radiologist Oncologist", "Tele Radiologist", "Radiologist, MBBS"]
    this.subOptionsvalue = this.subOptions[0]
    }

    else if(this.specialization=="Anesthetist"){
      this.subOptions=["Critical care medicine with Anesthesia", "Critical care medicine without Anesthesia"]
      this.subOptionsvalue = this.subOptions[0]
    }
    else if(this.specialization=="Pathologist"){
      this.subOptions=["Pathologist, MBBS", "Other Pathologists"]
      this.subOptionsvalue = "MBBS"
    }
    else if(this.specialization=="General Physician"){
      this.subOptions=["General Physician, MBBS", "Other General Physicians"]
      this.subOptionsvalue = this.subOptions[0]
    }
    else{
      this.subOptions=[];
      this.subOptionsvalue = ""
    }

      localStorage.setItem("specialisation", this.specialization)
  }

  selectSubOptions(){
    localStorage.setItem("subSpecialisation", this.subOptionsvalue)
  }
  submitSpecialization() {
    //this.loading = true;
    if(this.subOptionsvalue!==""){
      window.open(environment.pam2Url + '/profession/doctor-professional-indemnity-insurance/doctorpi-quote?prospect='
    + this.prospectId + '&specialization=' + this.specialization + '&subSpecialization=' + this.subOptionsvalue);
    }
    else{
      window.open(environment.pam2Url + '/profession/doctor-professional-indemnity-insurance/doctorpi-quote?prospect='
      + this.prospectId + '&specialization=' + this.specialization);
    }
    
    //localStorage.setItem("specialisation", this.specialization)
    //this.router.navigate(['doctor-professional-indemnity-quote']);
    
    
    // const selectedSpecialization = (<HTMLInputElement>document.getElementById("specialization")).value

    // var prospectId = localStorage.getItem('prospectIdPI');
    // var hostname = window.location.hostname;
    // if( hostname == "staging.securenow.app"  || hostname == "localhost"){
    //   window.location.replace("https://pamstaging.securenow.in/profession/doctor-professional-indemnity-insurance?isAmp=true&prospectId="+prospectId+"&buyingFor=Individual%20Practice&specialization="+selectedSpecialization);
    // }else if(hostname == "securenow.app"){
    //   window.location.replace("https://securenow.in/profession/doctor-professional-indemnity-insurance?isAmp=true&prospectId="+prospectId+"&buyingFor=Individual%20Practice&specialization="+selectedSpecialization);
    // }
  }

  ngOnDestroy(): void {
    this.onDestroy$.next();
    this.onDestroy$.complete();
    }
    

}
